import { Product, Brand, Announcement } from '../types';

// Brands and products are served from S3 catalogues via the backend API.
// These empty arrays are kept for type compatibility with mock mode.
export const mockBrands: Brand[] = [];

export const mockProducts: Product[] = [];

export const mockAnnouncements: Announcement[] = [
  // Uncomment to preview the announcement banner locally:
  // {
  //   announcementId: 'store-announcement',
  //   type: 'closed',
  //   active: true,
  //   title: 'Holiday Hours',
  //   message: 'We have modified hours over the long weekend.',
  //   lines: [
  //     'Monday Feb 1  – CLOSED',
  //     'Tuesday Feb 2 – 10am – 3pm',
  //     'Wednesday Feb 3 – Regular Hours',
  //   ],
  //   createdAt: new Date().toISOString(),
  //   updatedAt: new Date().toISOString(),
  // },
];
